export default (path) => {
  const parts = (path || "").split("/").filter(Boolean);
  const type = parts[0] || null;
  const idRaw = parts[1];
  const id = Number.isFinite(parseInt(idRaw, 10)) ? parseInt(idRaw, 10) : null;
  const plural = type ? pluralize(type) : null;
  return {
    id,
    singular: type,
    plural,
    apiBase: plural && id ? `${plural}/${id}` : null,
  };
};

const pluralize = (type) => {
  if (type === "building") {
    return "buildings";
  } else if (type === "business") {
    return "businesses";
  } else {
    return null;
  }
};
